import { lit, st } from "rdflib";
import { vcard } from "../namespaces.js";
export function removeContactFromGroup(contactQuery, groupQuery) {
    const contactUri = contactQuery.contactNode.uri;
    const member = groupQuery.queryMembers().find((it) => it.uri === contactUri);
    if (!member) {
        throw new Error("member not found in group");
    }
    return {
        insertions: [],
        deletions: [
            st(groupQuery.groupNode, vcard("hasMember"), contactQuery.contactNode, groupQuery.groupNode.doc()),
            st(contactQuery.contactNode, vcard("fn"), lit(member.name), groupQuery.groupNode.doc()),
        ],
        filesToCreate: [],
    };
}
//# sourceMappingURL=removeContactFromGroup.js.map